module.exports = __webpack_public_path__ + "img/share.ab5ef16f.svg";